import React from 'react';

const PopularParts = () => {
  const columns = [
    ['Alternator', 'Akumulator', 'Amortizeri', 'Disk kočnice', 'Kočione pločice', 'Kugle', 'Plin pumpa', 'Pogon na točkovima'],
    ['Filter za vazduh', 'Filter za gorivo', 'Filter za kabinu', 'Zadnja svetla', 'Prednja svetla', 'Farovi', 'Brisači', 'Svećice'],
    ['Vezni delovi volana', 'Remen za alternator', 'Karakteristični delovi za servo', 'Upravljački mehanizam', 'Branik', 'Bočne stene', 'Pneumatici', 'Kvačilo'],
    ['Upravljački mehanizam', 'Branik', 'Bočne stene', 'Pneumatici', 'Kvačilo', 'Radijator', 'Zupčasti remen', 'Motorna ulja i filteri'],
  ];

  return (
    <div style={styles.container}>
      <h3 style={styles.popularPartsHeading}>Najčešće traženi delovi</h3>

      <div style={styles.partsSection}>
        {columns.map((col, index) => (
          <div key={index} style={styles.column}>
            {col.map((item, idx) => (
              <p key={idx} style={styles.item}>{item}</p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PopularParts;

const styles = {
  container: {
    backgroundColor: 'rgb(23, 23, 24)',
    padding: '40px 40px',
  },
  popularPartsHeading: {
    fontSize: '48px',
    fontWeight: 700,
    backgroundImage: 'linear-gradient(235.42deg, #EEFF00 0%, #B6BB6C 100%)',
    backgroundClip: 'text',
    color: 'transparent',
    marginBottom: 16,
    lineHeight: '48px',
    textAlign: 'center',
  },
  partsSection: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    paddingBottom: 30,
  },
  column: {
    flex: '1 1 200px',
    margin: '10px 20px',
  },
  item: {
    color: '#ffffff',
    fontSize: '20px',
    marginBottom: 6,
  },
};
